export const SCROLL_ANIMATION_DURATION = 450;
export const easeInOutCubic = (progress) => progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
export const readTrackInset = (paddingLeft) => Number.parseFloat(paddingLeft) || 0;
export const mapCardScrollPositions = (cardLefts, trackLeft, inset, current, maxScroll) => cardLefts.map(left => {
    const offset = left - trackLeft - inset;
    return Math.max(0, Math.min(current + offset, maxScroll));
});
export const resolvePortfolioScrollTarget = (direction, current, maxScroll, cardPositions) => {
    if (direction > 0) {
        return cardPositions.find(position => position > current + 1) ?? maxScroll;
    }
    return cardPositions.findLast(position => position < current - 1) ?? 0;
};
